import getConfig from '../config'

const REACT_APP_FEATURE_MYFI_REPORTS = getConfig('myfiReportsFeatureFlag')

const REACT_APP_FEATURE_AUTH0 = getConfig('auth0FeatureFlag')

// Export all available feature flags
export const ENABLE_MYFI_REPORTS =
  (REACT_APP_FEATURE_MYFI_REPORTS &&
    REACT_APP_FEATURE_MYFI_REPORTS.toLowerCase() == 'true') ||
  false

export const ENABLE_AUTH0_AUTHENTICATION =
  (REACT_APP_FEATURE_AUTH0 &&
    REACT_APP_FEATURE_AUTH0.toLowerCase() == 'true') ||
  false
